module.exports = "/_next/static/images/0962fd188edbf3f50d922794efb3e4f5-nubanker-bizarch@3x.jpg.webp";